module.exports = "data:image/gif;base64,R0lGODlhCwALAKIAAAAAAP///6XOVf3++////wAAAAAAAAAAACH5BAEAAAQALAAAAAALAAsAAAMSKLrc3uOtESWt7mJ27YZSKAoJADs="